<template>
  <div>
    <navigation-bar></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 pb-5 ml-auto bg-light pt-5">
          <div class="mx-4">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavigationBar from '@/components/administration/NavigationBar'
  import organizationService from '@/services/amio-api/organization.service'

  export default {
    metaInfo: {
      title: 'Administration'
    },
    components: {
      'navigation-bar': NavigationBar
    },

    store: {
      organization: '_common.organization'
    },

    beforeRouteEnter(to, from, next) {
      organizationService.get()
        .then(organization => {
          next(vm => {
            vm.organization = organization
          })
        })
    }
  }
</script>
